/**
 * Anniversary Timeline Slider — anniversary-timeline.js
 * Uses Splide.js directly (splide.min.js loaded in theme.liquid).
 *
 * Layout:
 *   - Desktop: 1.5 slides visible, 1 per move, 64px padding
 *   - Tablet ≤1024px: 1.33 slides visible, 40px padding
 *   - Mobile ≤749px: 1 slide visible, no padding, arrows hidden
 */

(function () {
  'use strict';

  function initTimeline(section) {
    var splideEl = section.querySelector('.anntl__splide');
    var dots     = section.querySelectorAll('.anntl__dot');
    var prevBtn  = section.querySelector('.anntl__arrow--prev');
    var nextBtn  = section.querySelector('.anntl__arrow--next');

    if (!splideEl) return;

    /* ── 1. Entry animation ── */
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          section.classList.add('anntl--visible');
          observer.unobserve(section);
        }
      });
    }, { threshold: 0.12 });
    observer.observe(section);

    /* ── 2. Initialise Splide ── */
    var splide = new Splide(splideEl, {
      type      : 'slide',   /* no loop */
      rewind    : false,     /* no wrap-around */
      perPage   : 1,         /* always 1 full slide active... */
      perMove   : 1,
      gap       : '16px',
      drag      : false,     /* arrows only — no drag/swipe */
      padding   : { left: '64px', right: '35%' }, /* ...with 35% space on the right revealing the next slide */
      pagination: false,     /* custom year dots */
      arrows    : false,     /* custom arrow buttons */
      breakpoints: {
        1024: {
          drag    : false,
          padding : { left: '40px', right: '25%' } /* tablet peek */
        },
        749: {
          drag    : false,
          padding : 0 /* full width on mobile */
        }
      }
    });

    /* ── 3. Sync year dots ── */
    function syncDots(index) {
      dots.forEach(function (dot, i) {
        var active = (i === index);
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
        if (active) {
          /* Manual scroll on the dots container only, to avoid bubbling to hub panels */
          var container = dot.parentElement;
          if (container) {
            var scrollPos = dot.offsetLeft - (container.offsetWidth / 2) + (dot.offsetWidth / 2);
            container.scrollTo({ left: scrollPos, behavior: 'smooth' });
          }
        }
      });
    }

    /* ── 4. Sync arrow disabled state ── */
    function syncArrows(index) {
      if (prevBtn) prevBtn.disabled = (index <= 0);
      if (nextBtn) nextBtn.disabled = (index >= splide.length - 1);
    }

    /* ── 5. Listen on 'moved' (past tense) — fires AFTER the slide settles,
       so splide.index is already the correct new index. ── */
    splide.on('moved', function (newIndex) {
      syncDots(newIndex);
      syncArrows(newIndex);
    });

    /* 'mounted' fires once when Splide is ready */
    splide.on('mounted', function () {
      syncDots(splide.index);
      syncArrows(splide.index);
    });

    /* ── 6. Year dot clicks ── */
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        splide.go(i);
      });
    });

    /* ── 7. Custom arrow clicks ── */
    if (prevBtn) prevBtn.addEventListener('click', function () { splide.go('-1'); });
    if (nextBtn) nextBtn.addEventListener('click', function () { splide.go('+1'); });

    /* ── 8. Mount ── */
    splide.mount();
  }

  /* ── Boot ── */
  function bootAll() {
    document.querySelectorAll('.anniversary-timeline').forEach(function (section) {
      if (section.dataset.anntlInit) return;
      section.dataset.anntlInit = '1';
      initTimeline(section);
    });
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.anniversary-timeline');
    if (section) {
      delete section.dataset.anntlInit;
      initTimeline(section);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

})();
